// 표 헤더 스티키 오프셋 — 어댑터(TableRender)와 codegen(core.Table emit)이 같은 값을 쓴다.
//
// DS table.css 규칙(pbo-core #408):
//  · `.pbo-v2-actionbar-sticky` top 0 · 높이 40 + 아래 덮개 8 → 표 헤더는 48 아래(STICKY_OFFSET_ACTIONBAR)
//  · 스티키 타이틀(`.dev-page-header-wrap.pin`)이 같은 페이지 위에 있으면 액션바는 56 아래(타이틀 40 + 블록 gap 16)
//    → 표 헤더는 56 + 48 = 104. 48 로 두면 헤더가 z 20 액션바 밑에 깔려 스크롤 중 컬럼 제목이 사라진다(moms-fe sy10 2026-10-02).

/** 액션바(40) + 덮개(8) — 저장본 stickyOffset 의 '액션바만' 값(skeletonBuilders tableGroup). */
export const STICKY_OFFSET_ACTIONBAR = 48
/** 스티키 타이틀이 차지하는 띠 — 타이틀 행 40 + 페이지 블록 gap 16(DS table.css 액션바 top 56). */
export const STICKY_TITLE_BAND = 56

/**
 * 어댑터용 — 표 앞의 액션바가 실제로 멈추는 위치(computed top)를 더한다. 분할 패널·모달은 액션바 top 0 이라 그대로 48.
 * 저장본 값이 '액션바만'(48)이 아니면(상태 탭 102 등) 손대지 않는다 — codegen 과 같은 범위.
 */
export function resolveTableStickyOffset(base: number | undefined, actionBarTop: number | null): number | undefined {
  if (base !== STICKY_OFFSET_ACTIONBAR || actionBarTop == null || actionBarTop <= 0) return base
  return actionBarTop + STICKY_OFFSET_ACTIONBAR
}
